import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { UserProvider } from "../user/user";
import { ContribuaProvider } from "../contribua/contribua";
import { finalize } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import { LoadingController } from "@ionic/angular";
import { History } from "src/app/interfaces/meeting.interface";
import { PerfilProfissional } from "src/app/interfaces/perfil-profissional";

@Injectable({ providedIn: "root" })
export class profissionalProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(
    public http: HttpClient,
    public userProvider: UserProvider,
    public ContribuaProvider: ContribuaProvider,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
  ) {}

  salvarPerfilProfissional(dados: any) {
    return this.http
      .post<PerfilProfissional>(this.baseUrl + "/perfil-profissional/salvar-perfil-profissional", dados)
      .pipe(
        map((data) => {
          return data;
        }),
      );
  }

  buscarEmpresa(idPessoa: any) {
    return this.http.get<any>(this.baseUrl + "/perfil-profissional/buscar-perfil", {
      params: { idPessoa },
    });
  }

  listaProfissionais(filtro: any) {
    return this.http.get<any>(this.baseUrl + "/perfil-profissional/buscar-profissionais", {
      params: {
        filtro,
      },
    });
  }
}
